import { createAction } from 'redux-actions';
import { LoadingType } from '../types';

export const SET_LOADING = 'EXCHANGE/SET_LOADING';

export const setLoading = createAction<LoadingType>(SET_LOADING);

export type SetLoadingAction = ReturnType<typeof setLoading>;

export const STOP_LOADING = 'EXCHANGE/STOP_LOADING';

export const stopLoading = createAction(STOP_LOADING);

export type StopLoadingAction = ReturnType<typeof stopLoading>;
